"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const utils_1 = require("../utils");
const color_1 = require("../utils/color");
const constants_1 = require("../utils/constants");
const styled_1 = __importDefault(require("../utils/styled"));
const shouldForwardProp = (prop) => !["color", "left", "assignColor", "condensed"].includes(prop);
const Container = styled_1.default("div", {
    shouldForwardProp,
})(({ theme, color, left, right, children, assignColor, condensed }) => {
    const backgroundColor = assignColor
        ? color_1.colorMapper(theme.color.palette)(children)
        : constants_1.expandColor(theme, color) || theme.color.primary;
    const textColor = utils_1.readableTextColor(backgroundColor, [theme.color.white, theme.color.black]);
    return Object.assign({ backgroundColor, color: textColor, fontSize: condensed ? theme.font.size.tag : theme.font.size.small, fontWeight: theme.font.weight.bold, fontStretch: "condensed", width: condensed ? 16 : 28, height: condensed ? 14 : 20, borderRadius: theme.borderRadius, display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }, (left ? { marginRight: theme.space.small } : {}), (right ? { marginLeft: theme.space.small } : {}));
});
const NameTag = (_a) => {
    var { condensed, children } = _a, props = __rest(_a, ["condensed", "children"]);
    return (React.createElement(Container, Object.assign({}, props, { condensed: Boolean(condensed), assignColor: !props.color }), children || ""));
};
NameTag.defaultProps = {
    children: "",
};
exports.default = NameTag;
//# sourceMappingURL=NameTag.js.map